import { isString } from 'lodash';

import { ValidationRule } from '@/mixins/validation/validator';

export const maxLength: (max: number) => ValidationRule = max => value => {
	const isValid = isString(value) && value.trim().length <= max;

	return isValid || `Should be no longer than ${max} characters`;
};
